import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const TenantContext = createContext(null);

export const useTenant = () => {
  const context = useContext(TenantContext);
  if (!context) throw new Error('useTenant must be used within TenantProvider');
  return context;
};

export const TenantProvider = ({ children }) => {
  const { slug } = useParams();
  const { user, token } = useAuth();
  const navigate = useNavigate();
  const [tenantInfo, setTenantInfo] = useState(null);
  const [tenantError, setTenantError] = useState(null);

  const API_URL = window.location.origin + '/api';

  useEffect(() => {
    if (!slug) return;
    // Super admins can access any tenant — skip redirect
    if (user?.is_super_admin) {
      setTenantInfo({ slug });
      setTenantError(null);
      return;
    }
    // Regular users: validate tenant slug matches user's company
    if (user && user.company_slug && user.company_slug !== slug) {
      navigate(`/t/${user.company_slug}/dashboard`, { replace: true });
      return;
    }
    setTenantInfo({ slug });
    setTenantError(null);
  }, [slug, user, navigate]);

  const tenantHeaders = useMemo(() => {
    if (!slug) return {};
    return { 'X-Tenant-Slug': slug };
  }, [slug]);

  const value = {
    slug,
    tenantInfo,
    tenantError,
    tenantHeaders,
  };

  return (
    <TenantContext.Provider value={value}>
      {children}
    </TenantContext.Provider>
  );
};
